export const getDashboardDateRangeForPreset = preset => ({
  type: preset.presetId,
  startDate: preset.getValue().startDate,
  endDate: preset.getValue().endDate
});